import React from "react";

function ChevronIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#425466"
        d="M11.947 5.453H4.053c-.64 0-.96.773-.506 1.227L7 10.133a1.42 1.42 0 002.007 0L10.32 8.82l2.14-2.14a.721.721 0 00-.514-1.227z"
      ></path>
    </svg>
  );
}

export default ChevronIcon;
